import { NgModule } from '@angular/core';
import { TrapFocusDirective } from './trap-focus/trap-focus.directive';
import { AutoFocusDirective } from './auto-focus/auto-focus.directive';
import { CommonModule } from '@angular/common';
import { WindowService } from '../services/popr-service/window.service';
import { ExternalLinkDirective } from './external-link/external-link.directive';

@NgModule({
  declarations: [
    TrapFocusDirective,
    AutoFocusDirective,
    ExternalLinkDirective

  ],
  providers: [
    WindowService
  ],
  imports: [
    CommonModule
  ],
  exports: [
    TrapFocusDirective,
    AutoFocusDirective,
    ExternalLinkDirective
  ]
})
export class DirectivesModule {
}
